import { defineMessages } from "react-intl";

/** COM-506 — fixed UI strings of the Insiders claim form (merchandiser copy comes in through Builder inputs). */
const messages = defineMessages({
  signInToClaim: {
    id: "loyalty.insidersClaim.sign_in_to_claim",
    defaultMessage: "Sign in to claim",
  },
  genericFailure: {
    id: "loyalty.insidersClaim.generic_failure",
    defaultMessage: "Something went wrong. Please try again.",
  },
  enrollNow: {
    id: "loyalty.insidersClaim.enroll_now",
    defaultMessage: "Enroll now",
  },
  enrollToClaim: {
    id: "loyalty.insidersClaim.enroll_to_claim",
    defaultMessage: "Enroll in Perks to claim these points.",
  },
});

export default messages;
